import type { ReactNode } from 'react'
import { Link } from 'react-router'

interface Props {
  children: ReactNode
  id?: string
  /** "See all" link. */
  more?: { to: string; label?: string }
}

export default function SectionHeading({ children, id, more }: Props) {
  return (
    <div className="flex items-baseline justify-between gap-4">
      <h2 id={id} className="text-2xl font-extrabold text-qt-text md:text-[32px]">
        {children}
      </h2>
      {more && (
        <Link to={more.to} className="shrink-0 text-[15px] font-bold text-qt-primary hover:underline">
          {more.label ?? 'See all'} <span aria-hidden="true">→</span>
        </Link>
      )}
    </div>
  )
}
